import {Module, Mutation, VuexModule} from "vuex-module-decorators";
import ProductType from "@/app/models/ProductType";
import Division from "@/app/models/Division";
import Station from "@/app/models/Station";

@Module({namespaced: true})
export default class DataModule extends VuexModule {
    productTypes: ProductType[] = [];
    divisions: Division[] = [];
    station: Station|null = null;

    @Mutation
    setProductTypes(productTypes: ProductType[]): void {
        this.productTypes = productTypes;
    }

    @Mutation
    setDivisions(divisions: Division[]): void {
        this.divisions = divisions;
    }

    @Mutation
    setStation(station: Station): void {
        this.station = station;
    }
}